export enum CandidateStatus {
  ResumeExtracting = 'resume_extracting',
  Active = 'active',
  Fatal = 'fatal'
}

export function getCandidateStatusLabel(status: CandidateStatus): string {
  switch (status) {
    case CandidateStatus.ResumeExtracting:
      return 'Resume Extracting';
    case CandidateStatus.Active:
      return 'Active';
    case CandidateStatus.Fatal:
      return 'Fatal';
    default:
      return 'Unknown';
  }
}
